module.exports = __webpack_public_path__ + "img/external-link.0db05191.png";